import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../firebase.ts";
import { useState } from "react";

export interface CompanyInfoByInvoice {
  invoiceNumber: string;
  clientCompanyName: string;
  prefecture: string;
  address1: string;
}

interface RequestByInvoice {
  invoiceNumber: string;
}

// Interface for parsed CSV data to maintain compatibility with existing UI
export interface ResponseByInvoice {
  companyInfoList: CompanyInfoByInvoice[];
}

export const useCompanyInfoByInvoice = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>("");
  const [companyInfoList, setCompanyInfoList] = useState<CompanyInfoByInvoice[]>([]);

  const getCompanyInfo = async (invoiceNumber: string): Promise<CompanyInfoByInvoice[]> => {
    setIsLoading(true);
    setError("");

    try {
      const functions = getFirebaseFunctions();
      const getCompanyInfoFunction = httpsCallable<RequestByInvoice, ResponseByInvoice>(
        functions,
        "getCompanyInfoByInvoice",
      );
      const res = await getCompanyInfoFunction({
        invoiceNumber,
      });

      const data = res.data.companyInfoList;
      setCompanyInfoList(data);
      return data;
    } catch (err) {
      const error = err instanceof Error ? err : new Error(String(err));
      setError(error.message);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { getCompanyInfo, isLoading, error, companyInfoList };
};
